export default __webpack_public_path__ + "static/media/bd-exec-2.e4fc8869.jpg";